import React from 'react';
import PropTypes from 'prop-types';

const OptionalSection = ({
  section: Section,
  renderCondition,
}) => (
  renderCondition ? <Section /> : null
);

OptionalSection.propTypes = {
  renderCondition: PropTypes.bool,
  section: PropTypes.func,
};

export default OptionalSection;
